import React, {useEffect, useState} from 'react';
import {TextInput} from 'react-native';

const OrderItemQtyInput = ({item, canEdit, onCommit, onCancel, ...inputProps}) => {
  const savedQty = item.iteminfo.qty;
  const [value, setValue] = useState(savedQty);

  useEffect(() => {
    setValue(savedQty);
  }, [savedQty]);

  const commit = async () => {
    const qty = parseInt(value, 10);
    if (Number.isNaN(qty) || String(qty) === String(savedQty)) {
      setValue(savedQty);
      if (onCancel) onCancel();
      return;
    }
    const saved = await onCommit({...item, iteminfo: {...item.iteminfo, qty}});
    if (saved !== true) {
      setValue(savedQty);
    }
  };

  return (
    <TextInput
      {...inputProps}
      value={value === null || value === undefined ? '' : String(value)}
      onChangeText={text => {
        if (canEdit()) {
          setValue(text);
        }
      }}
      onSubmitEditing={commit}
      onBlur={commit}
    />
  );
};

export default OrderItemQtyInput;
